import CompanyNews from '../companyNews/src/index.vue'

export default CompanyNews